import { AGSResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { AGSWin, AGSWinTypes } from "ags/integration/schema/ags-spin-response-schema";
import Record from "slotworks/model/gameplay/records/record";
import BonusResult from "slotworks/model/gameplay/records/results/bonus-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class PickTriggerResultBuilder extends AGSResultBuilder implements ResultBuilder {

    public filter(data: any): boolean {
        const win = data as AGSWin;
        return win.evaluationType && win.evaluationType.toLowerCase() === AGSWinTypes.RANDOM;
    }

    public build(record: Record, data: any): Result[] {
        const agsWin = data as AGSWin;

        return [new BonusResult(agsWin.featureType)];
    }
}

export default new PickTriggerResultBuilder();
